import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { D1PortfoliosEditCard } from "./edit_card";
import { Clients } from "@/lib/clients";

import { Tables } from "@/gen/tableNames/tables";

export const D1PortfoliosEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full relative">
      <div className="flex flex-col gap-10 p-10">
        <D1PortfoliosEditCard
          id={Number(id)}
          client={Clients.D1}
          table_name={Tables.D1_PORTFOLIOS}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.D1}
          audit_table_name={Tables.D1_PORTFOLIOS}
        />
      </div>
    </div>
  );
};
